import { IListing } from "../../@types/listing";
import { BaseServiceFactory } from "../types/base";
import { KnockServices } from "./types";
import { analyticsEventActions } from "../../app/utils/constants";

export class KnockFactory implements BaseServiceFactory {
  listing: IListing;

  constructor(listing: IListing) {
    this.listing = listing;
  }

  create(): KnockServices {
    return {
      init_key: this.listing.knock_init_key,
      community_id: this.listing.knock_community_id,
      hide: this.listing.hide_knock_widget,
      mobile: {
        contact: this.listing.has_mobile_knock_contact_property,
        schedule: this.listing.has_mobile_knock_schedule_tour,
        availability: this.listing.has_mobile_knock_prices_avail,
        photos: this.listing.has_mobile_knock_photos,
        neighborhood: this.listing.has_mobile_knock_neighborhood,
        requestText: this.listing.has_mobile_knock_request_text,
      },
      more: {
        contact: this.listing.knock_contact_property,
        schedule: this.listing.knock_schedule_tour,
        availability: this.listing.knock_prices_avail,
        photos: this.listing.knock_photos,
        neighborhood: this.listing.knock_neighborhood,
        requestText: this.listing.knock_request_text,
      },
      desktop: {
        contact: this.listing.has_desktop_knock_contact_property,
        schedule: this.listing.has_desktop_knock_schedule_tour,
        availability: this.listing.has_desktop_knock_prices_avail,
        photos: this.listing.has_desktop_knock_photos,
        neighborhood: this.listing.has_desktop_knock_neighborhood,
        requestText: this.listing.has_desktop_knock_request_text,
      },
      events: {
        opens: {
          contact: analyticsEventActions.opens_knock_contact_property,
          schedule: analyticsEventActions.opens_knock_schedule_tour,
          availability: analyticsEventActions.opens_knock_prices_avail,
          photos: analyticsEventActions.opens_knock_photos,
          neighborhood: analyticsEventActions.opens_knock_neighborhood,
          requestText: analyticsEventActions.opens_knock_request_text,
        },
      }
    };
  }
}
